interface CodeRenderProps {
  children: string;
}

export default function CodeRender(props: CodeRenderProps) {
  const { children } = props;
  const dangerousHtml = { __html: children };
  return (
    <pre><code dangerouslySetInnerHTML={dangerousHtml} /></pre>
  )
}